import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Fade } from 'react-reveal'

const ImageBanner = ({ image, withinGrid, halfHeight }) => {

  return (
    <section className={`image-banner ${withinGrid ? 'image-banner--grid' : ''} ${halfHeight ? 'image-banner--half' : ''}`}>
      <Fade bottom distance='40px'>
        <div className='image-banner__inner'>
          { image?.localFile && <GatsbyImage image={ image.localFile.childImageSharp.gatsbyImageData } alt=''/> }
        </div>
      </Fade>
    </section>
  )
}

export default ImageBanner